import CommonService from "../Common";
import { AxiosRequestConfig } from "axios";

interface FeedbackSettings {
  pathPrefix?: string;
  commonService: CommonService;
}

interface FeedbackData {
  userId: string;
  documentId: string;
  documentType: "icp" | "adstrategy" | "adinsights" | "competitiveanalysis";
  feedback: boolean; // true = positive, false = negative
  feedbackContext?: string;
}

class FeedbackService implements FeedbackSettings {
  pathPrefix?: string;
  commonService: CommonService;

  constructor() {
    this.pathPrefix = "/api/v1/projects";
    this.commonService = new CommonService();
  }

  /**
   * Store feedback for a document
   * @param projectId - The ID of the project containing the document
   * @param feedbackData - The feedback data to store
   * @returns Promise with the API response
   */
  storeFeedback(projectId: string, feedbackData: FeedbackData) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${this.pathPrefix}/${projectId}/feedback`,
      data: feedbackData,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }
}

export default FeedbackService;
